import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

export default function FinishTestPage() {
	useEffect(() => {
		if (window.parent && window.parent !== window) {
			window.parent.postMessage(
				{
					type: 'finish-test',
				},
				window.location.origin
			)
		}
	}, [])

	return (
		<>
			<Helmet>
				<title>Завершение теста</title>
			</Helmet>
			<div
				style={{
					minHeight: '100vh',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					background: '#FFFFFF',
					color: '#0E142F',
					fontFamily: 'Montserrat, sans-serif',
					padding: '24px',
					boxSizing: 'border-box',
					textAlign: 'center',
				}}
			>
				Завершение теста...
			</div>
		</>
	)
}
